import React, { Component } from 'react'
import { Col, Card, Image } from 'react-bootstrap';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter, Link } from "react-router-dom";
import * as Cookies from "es-cookie";
import moment from 'moment';
import { ExamCardsSkeleton } from '../fresh/HomeSkeleton';
const FETCH_SCHEUDULE = gql` 
query($student_user_exam_id: Int!, $upcoming_only: Boolean) {
    getScheduledExams(student_user_exam_id: $student_user_exam_id, upcoming_only: $upcoming_only){
        id
        exam_name
    exam_type
    start_time
    end_time
    is_completed
   }
}

`;
class ExamsCard extends Component {
    examImage(examid) {

        if (examid == "1") {
            return (require('../../../../images/Neet-Exam.png'));
        } else if (examid == "2") {
            return (require('../../../../images/Jee(Mains)-Exam.png'));
        }
        else if (examid == "3" || examid == "6") {
            return (require('../../../../images/tschelogo.png'));
        }
        else if (examid == "7" || examid == "8") {
            return (require('../../../../images/Jntuk-logo.png'));
        }
    }
    asideCard(data) {
        let getData = data[this.props.stateData.mainindex];
        let classname = "";
        if (getData.subject == "Botany") {
            classname = "aside-card my-3 botany"
        }
        else if (getData.subject == "Physics") {
            classname = "aside-card my-3 physics"
        }
        else if (getData.subject == "Chemistry") {
            classname = "aside-card my-3"
        }
        else if (getData.subject == "Zoology") {
            classname = "aside-card my-3 zoology"
        }
        else if (getData.subject == "Mathematics") {
            classname = "aside-card my-3 maths"
        }
        return classname;

    }
    render() {
        //console.log("v678", this.props.studentGlobals.exams);
        const getScheduledExams = this.props.getScheduledExams;
        const loading1 = getScheduledExams.loading;
        const error1 = getScheduledExams.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }
        if (loading1) {
            return <ExamCardsSkeleton />;
        }
        else {
            let now = moment().unix();
            const upcommingexams = getScheduledExams.getScheduledExams.filter((data) => now < data.start_time && data.is_completed == false)
            const currentexams = getScheduledExams.getScheduledExams.filter((data) => now > data.start_time && now <= data.end_time && data.is_completed == false)

            const examLabel = (item) => {
                const exam = this.props.studentGlobals.exams.find((data) => data.id == item.exam_type);
                return exam ? exam.exam : "";
            };

            return (
                <React.Fragment>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-3">
                        <Card className="exam-name exam-fresh exam-fresh--current h-100">
                            <div className="exam-fresh-head">
                                <i className="fad fa-clipboard-list exam-fresh-icon" aria-hidden="true" />
                                <div className="exam-fresh-text">
                                    <h6 className="exam-fresh-title">Current Exam</h6>
                                    <p className="exam-fresh-status mb-0">
                                        {currentexams.length > 0 ? `${currentexams.length} live now` : "None Assigned"}
                                    </p>
                                </div>
                                <Link to="/student/exams/schedule-exam" className="exam-fresh-btn">
                                    View Exams <i className="far fa-chevron-right ml-2" aria-hidden="true" />
                                </Link>
                            </div>
                            {currentexams.length > 0 ? (
                                <ul className="exam-fresh-list list-unstyled mb-0">
                                    {currentexams.map((item) => (
                                        <li key={item.id} className="exam-fresh-item">
                                            <Image src={this.examImage(item.exam_type)} roundedCircle alt="" />
                                            <div className="exam-fresh-item-text">
                                                <strong>{examLabel(item)}</strong>
                                                <span>{item.exam_name}</span>
                                            </div>
                                            <button
                                                type="button"
                                                className="exam-fresh-start"
                                                onClick={() => this.props.startexamFun(item, this.props.isuserValid.schedule_exam)}
                                            >
                                                Start Exam
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            ) : null}
                        </Card>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-3">
                        <Card className="exam-name exam-fresh exam-fresh--upcoming h-100">
                            <div className="exam-fresh-head">
                                <i className="fad fa-calendar-alt exam-fresh-icon" aria-hidden="true" />
                                <div className="exam-fresh-text">
                                    <h6 className="exam-fresh-title">Upcoming Exam</h6>
                                    <p className="exam-fresh-status mb-0">
                                        {upcommingexams.length > 0 ? `${upcommingexams.length} scheduled` : "None Assigned"}
                                    </p>
                                </div>
                                <Link to="/student/exams/schedule-exam" className="exam-fresh-btn">
                                    View Schedule <i className="far fa-chevron-right ml-2" aria-hidden="true" />
                                </Link>
                            </div>
                            {upcommingexams.length > 0 ? (
                                <ul className="exam-fresh-list list-unstyled mb-0">
                                    {upcommingexams.map((item) => (
                                        <li key={item.id} className="exam-fresh-item">
                                            <Image src={this.examImage(item.exam_type)} roundedCircle alt="" />
                                            <div className="exam-fresh-item-text">
                                                <strong>{examLabel(item)}</strong>
                                                <span>{item.exam_name}</span>
                                            </div>
                                            <span className="exam-fresh-date">{moment.unix(item.start_time).format("DD MMM, LT")}</span>
                                        </li>
                                    ))}
                                </ul>
                            ) : null}
                        </Card>
                    </Col>
                </React.Fragment>
            )
        }
    }
}

export default withRouter(compose(
    graphql(FETCH_SCHEUDULE,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                    upcoming_only: true
                }
                ,
                fetchPolicy: "cache-and-network"
            }), name: "getScheduledExams"
        })
)(ExamsCard));